import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: Crumb[];
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full border-b border-background-200 bg-background-100">
      <ol className="mx-auto flex w-full max-w-content flex-wrap items-center gap-2 px-4 py-3 font-label text-xs text-foreground-500 md:px-6 md:text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="inline-flex items-center gap-1 transition-colors hover:text-primary-600">
                  {index === 0 && <i className="ri-home-4-line" />}
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800" aria-current="page">
                  {item.label}
                </span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}